import { render, staticRenderFns } from "./modifyDiamondOrder.vue?vue&type=template&id=4df680dc&scoped=true&"
import script from "./modifyDiamondOrder.vue?vue&type=script&lang=js&"
export * from "./modifyDiamondOrder.vue?vue&type=script&lang=js&"
import style0 from "./modifyDiamondOrder.vue?vue&type=style&index=0&id=4df680dc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df680dc",
  null
  
)

export default component.exports